/* =====================================================================
   cart-page.js — PIEZA 3
   AJAX para la página de carrito 2 columnas (qty +/- y remove sin recargar).
   Progressive enhancement: si JS falla o no carga, los links GET
   /cart/change siguen funcionando (degradación elegante).
   Reusa los patrones de fetch /cart/change.js + el shape de cart.js que ya
   usa global.js (final_line_price, total_price en centavos, item.key, etc.).
   Scope: solo opera dentro de #cart-page-root. NO toca global.js ni el drawer.
   ===================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('cart-page-root');
  if (!root) return;

  /* Formato de precio money MXN — fuente única compartida con global.js
     (window.Theme.money). Replica el render de Liquid `| money`:
     símbolo + miles + 2 decimales + ' MXN'. Fallback local por si global.js
     aún no cargó (defer preserva el orden, pero mantenemos la red de seguridad). */
  function money(cents) {
    if (window.Theme && typeof window.Theme.money === 'function') {
      return window.Theme.money(cents);
    }
    return '$' + (Number(cents) / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' MXN';
  }

  /* ---- Shipping bar: misma lógica/markup que global.js (hooks intactos) ---- */
  function refreshShipping(cart) {
    var el = document.getElementById('cart-page-shipping-bar');
    if (!el) return;

    var thresholdMXN = parseInt(el.getAttribute('data-threshold') || '0', 10);
    var thresholdCents = thresholdMXN * 100;
    var textEl = el.querySelector('#cart-page-shipping-bar-text');
    var fillEl = el.querySelector('#cart-page-shipping-bar-fill');
    var textProgress = el.getAttribute('data-text-progress') || '';
    var textUnlocked = el.getAttribute('data-text-unlocked') || '';
    if (!thresholdCents) return;

    var progressEl = fillEl ? fillEl.parentElement : null;

    if (cart.item_count === 0) {
      var textEmpty = el.getAttribute('data-text-empty') || '';
      if (textEl) { textEl.textContent = textEmpty; textEl.classList.remove('cart-shipping-bar__text--success'); }
      if (fillEl) { fillEl.style.width = '0%'; }
      if (progressEl) { progressEl.classList.remove('has-progress'); }
      el.classList.remove('is-unlocked');
    } else if (cart.total_price >= thresholdCents) {
      if (textEl) { textEl.textContent = '✓ ' + textUnlocked; textEl.classList.add('cart-shipping-bar__text--success'); }
      if (fillEl) { fillEl.style.width = '100%'; }
      if (progressEl) { progressEl.classList.add('has-progress'); }
      el.classList.add('is-unlocked');
    } else {
      var remainingFormatted = money(thresholdCents - cart.total_price);
      var pct = Math.min(100, Math.round((cart.total_price / thresholdCents) * 100));
      if (textEl) { textEl.innerHTML = textProgress.replace('{amount}', remainingFormatted); textEl.classList.remove('cart-shipping-bar__text--success'); }
      if (fillEl) { fillEl.style.width = pct + '%'; }
      if (progressEl) { progressEl.classList.add('has-progress'); }
      el.classList.remove('is-unlocked');
    }
  }

  /* ---- Re-render de una fila de item ---- */
  function renderRow(row, item) {
    var numEl = row.querySelector('.cart-page__num');
    var amtEl = row.querySelector('.cart-page__amt');
    var minus = row.querySelector('[data-step="minus"]');
    var plus = row.querySelector('[data-step="plus"]');

    if (numEl) numEl.textContent = item.quantity;
    if (amtEl) amtEl.textContent = money(item.final_line_price);

    /* Precio unitario "c/u": solo cuando quantity > 1 (mismo criterio que el Liquid). */
    var priceEl = row.querySelector('.cart-page__price');
    var unitEl = row.querySelector('.cart-page__unit');
    if (item.quantity > 1) {
      if (!unitEl && priceEl) {
        unitEl = document.createElement('span');
        unitEl.className = 'cart-page__unit';
        priceEl.appendChild(unitEl);
      }
      if (unitEl) unitEl.textContent = money(item.final_price) + ' c/u';
    } else if (unitEl) {
      unitEl.parentNode.removeChild(unitEl);
    }

    /* Mantén los href GET sincronizados para la degradación sin JS. */
    if (minus) minus.setAttribute('href', '/cart/change?id=' + item.key + '&quantity=' + (item.quantity - 1));
    if (plus) plus.setAttribute('href', '/cart/change?id=' + item.key + '&quantity=' + (item.quantity + 1));
  }

  /* ---- Aplica cart.js completo a la página ---- */
  function applyCart(cart) {
    /* Contador y subtotal/total */
    var countEl = document.getElementById('cart-page-count');
    if (countEl) {
      var noun = cart.item_count === 1 ? 'producto' : 'productos';
      countEl.textContent = cart.item_count + ' ' + noun;
    }
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = money(cart.total_price);
    });

    var list = document.getElementById('cart-page-list');
    var removed = [];

    /* Actualiza filas existentes; marca para borrar las que llegaron a 0 */
    root.querySelectorAll('.cart-page__row').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (item) {
        renderRow(row, item);
        row.classList.remove('is-updating');
      } else {
        removed.push(row);
      }
    });
    removed.forEach(function (row) { row.parentNode.removeChild(row); });

    refreshShipping(cart);

    /* Carrito vacío → recarga para que Liquid pinte el empty-state canónico */
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
  }

  function setUpdating(row, on) {
    if (row) row.classList.toggle('is-updating', !!on);
  }

  /* ---- h9: render centralizado — CUALQUIER mutación (de esta página, del
     drawer o de un add) emite 'cart:updated' y este listener repinta. ---- */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.items) applyCart(e.detail);
  });

  /* ---- h6: mutación vía la cola serializada global (window.Theme.cartChange),
     que emite cart:updated. Red de seguridad local si global.js no cargó. ---- */
  function cartChange(key, qty) {
    if (window.Theme && typeof window.Theme.cartChange === 'function') {
      return window.Theme.cartChange(key, qty);
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/change ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }

  /* h6: estado optimista EN MEMORIA — mientras hay POSTs en vuelo la verdad
     vive aquí, no en el DOM (que va atrasado un render). */
  var optimisticQty = {};
  var pendingChanges = 0;

  function changeItem(key, qty, row) {
    optimisticQty[key] = qty;
    pendingChanges++;
    setUpdating(row, true);
    cartChange(key, qty)
      .then(function () {
        pendingChanges--;
        if (pendingChanges === 0) optimisticQty = {};
      })
      .catch(function () {
        pendingChanges--;
        if (pendingChanges === 0) optimisticQty = {};
        /* Fallback: deja que el navegador siga el link GET nativo */
        setUpdating(row, false);
        window.location.href = '/cart/change?id=' + key + '&quantity=' + qty;
      });
  }

  /* ---- Delegación de eventos (qty +/- y remove) ---- */
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    var remove = e.target.closest('.cart-page__remove');
    if (!step && !remove) return;

    e.preventDefault();
    var row = e.target.closest('.cart-page__row');
    if (!row) return;
    var key = row.getAttribute('data-key');
    if (!key) return;

    if (remove) {
      changeItem(key, 0, row);
      return;
    }

    var numEl = row.querySelector('.cart-page__num');
    /* h6: lee del estado optimista primero; el textContent solo es válido
       cuando no hay requests pendientes. */
    var current = Object.prototype.hasOwnProperty.call(optimisticQty, key)
      ? optimisticQty[key]
      : (parseInt(numEl ? numEl.textContent : '1', 10) || 1);
    var dir = step.getAttribute('data-step');
    var next = dir === 'plus' ? current + 1 : current - 1;
    if (next < 0) next = 0;
    if (numEl) numEl.textContent = next; /* feedback inmediato */
    changeItem(key, next, row);
  });

  /* ---- Nota del pedido: guarda con debounce vía /cart/update.js ---- */
  var noteEl = document.getElementById('cart-page-note');
  if (noteEl) {
    var noteTimer;
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        /* Fix 5: neutraliza formula injection (Excel/Sheets ejecuta =,+,-,@ al abrir exports) */
        var noteValue = noteEl.value;
        if (/^[=+\-@]/.test(noteValue)) {
          noteValue = "'" + noteValue;
        }
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteValue })
        }).catch(function () {});
      }, 600);
    });

    /* Cierre del gap residual: si el usuario escribe y presiona Pagar antes de
       que corra el debounce, el submit nativo mandaría la nota cruda. Se
       sanitiza el textarea síncronamente en el submit del form. */
    var cartForm = document.getElementById('cart-form');
    if (cartForm) {
      cartForm.addEventListener('submit', function () {
        if (/^[=+\-@]/.test(noteEl.value)) {
          noteEl.value = "'" + noteEl.value;
        }
      });
    }
  }
})();

/* ---- Descuento: toggle ya se maneja en global.js vía .cart__discount-toggle ----
   (delegado global, nextElementSibling + aria-expanded). No se duplica aquí. */
